import api from '@/services/api';

export type PublicRoomStatus = 'draft' | 'published' | 'unpublished';

export interface PublicRoomConfiguration {
  roomId: string;
  status: PublicRoomStatus;
  displayName: string;
  tagline: string;
  description: string;
  highlights: string[];
  sortOrder: number;
  defaultSessionId: string;
  createdBy: string;
  updatedBy: string;
  createdAtUnixMs: number;
  updatedAtUnixMs: number;
  publishedAtUnixMs: number;
  unpublishedAtUnixMs: number;
  sourceAvailable: boolean;
  shareAvailable: boolean;
}

export interface SavePublicRoomConfiguration {
  roomId: string;
  displayName: string;
  tagline: string;
  description: string;
  highlights: string[];
  sortOrder: number;
  defaultSessionId: string;
}

interface PublicRoomReply {
  room: PublicRoomConfiguration;
}
interface ListPublicRoomsReply {
  rooms: PublicRoomConfiguration[];
  nextOffset: number;
}

const base = '/api/v1/admin/public-rooms';
const roomPath = (roomId: string) => `${base}/${encodeURIComponent(roomId)}`;

export const publicRoomsApi = {
  list: (params: {
    status?: string;
    search?: string;
    pageSize?: number;
    offset?: number;
  }) => api.get<never, ListPublicRoomsReply>(base, { params }),
  get: (roomId: string) => api.get<never, PublicRoomReply>(roomPath(roomId)),
  create: (input: SavePublicRoomConfiguration) =>
    api.post<never, PublicRoomReply>(base, input),
  update: (input: SavePublicRoomConfiguration) =>
    api.patch<never, PublicRoomReply>(roomPath(input.roomId), input),
  publish: (roomId: string) =>
    api.post<never, PublicRoomReply>(`${roomPath(roomId)}/publish`, {}),
  unpublish: (roomId: string) =>
    api.post<never, PublicRoomReply>(`${roomPath(roomId)}/unpublish`, {}),
};
